var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, Link, SkeletonLine, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState } from 'react';
import { getViewReceipt } from '../../../api/oms/order-history';
import { useExperienceContext } from '../../../hooks/useContexts';
import { getWindow } from '../../../utils/general';
import { pushEReceiptOverlayEvent, setViewReceiptError, } from '../../../utils/purchase-history/analytics';
import { ViewReceiptAlert } from '../../order-details/util/AlertMessages';
import './receiptBarcode.css';
export var ViewReceipt = function (_a) {
    var _b, _c;
    var customerType = _a.customerType, encryptedReceiptRequest = _a.encryptedReceiptRequest, orderNumber = _a.orderNumber, orderOrigin = _a.orderOrigin, receiptImageSting = _a.receiptImageSting, text = _a.text, _d = _a.underline, underline = _d === void 0 ? true : _d, receiptNumber = _a.receiptNumber, page = _a.page;
    var thdCustomerInfo = useThdCustomer();
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), isDrawerOpen = _f[0], setIsDrawerOpen = _f[1];
    var _g = useState(null), receiptImage = _g[0], setReceiptImage = _g[1];
    var _h = useState(null), alertState = _h[0], setAlertState = _h[1];
    var handleViewReceipt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    pushEReceiptOverlayEvent();
                    if (!!isLoading) return [3 /*break*/, 6];
                    setIsLoading(true);
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 4, , 5]);
                    request = {
                        customerAccountId: thdCustomerInfo === null || thdCustomerInfo === void 0 ? void 0 : thdCustomerInfo.svocID,
                        encryptedReceiptRequest: encryptedReceiptRequest,
                    };
                    response = void 0;
                    if (!(request.customerAccountId && request.encryptedReceiptRequest)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getViewReceipt(request)];
                case 2:
                    response = _j.sent();
                    _j.label = 3;
                case 3:
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        setReceiptImage((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.receipt) === null || _b === void 0 ? void 0 : _b.receiptImage);
                        if (((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.receipt) === null || _d === void 0 ? void 0 : _d.receiptImage) === null ||
                            ((_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.receipt) === null || _f === void 0 ? void 0 : _f.receiptImage) === undefined) {
                            setIsLoading(false);
                            setAlertState({
                                alertMessage: 'We are unable to retrieve your receipt right now. Please try again later.',
                                status: 'error',
                            });
                            return [2 /*return*/];
                        }
                        if (page === 'purchase-history') {
                            printReceiptImage((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.receipt) === null || _h === void 0 ? void 0 : _h.receiptImage);
                            return [2 /*return*/];
                        }
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _j.sent();
                    setIsLoading(false);
                    setViewReceiptError(error_1);
                    if (setAlertState) {
                        setAlertState({
                            alertMessage: 'An error occurred while downloading your receipt. Please try again',
                            status: 'error',
                        });
                    }
                    return [3 /*break*/, 5];
                case 5:
                    setIsLoading(false);
                    _j.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var createReceiptImage = function () {
        setReceiptImage(receiptImageSting !== null && receiptImageSting !== void 0 ? receiptImageSting : '');
    };
    var printReceiptImage = function (responseImage) {
        var _a, _b;
        var receiptHTMLImage = String(receiptImage !== null && receiptImage !== void 0 ? receiptImage : responseImage);
        var html = receiptHTMLImage
            .replace(new RegExp('<div style="text-align:center">&nbsp;</div>', 'g'), '<br />')
            .replace(new RegExp('"'), '"');
        if (isConsumerApp) {
            var base64Image = btoa(html);
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.LIFE_CYCLE_EVENT_BUS.trigger('NATIVE_APP.PRINT_BASE64', {
                base64HtmlData: base64Image,
            });
            return;
        }
        var newPopupWindow = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.open('', '_blank', 'top=0,left=0,height=auto,width=auto,scrollbars=yes,resizable=no');
        if (newPopupWindow) {
            newPopupWindow.document.open();
            newPopupWindow.document.write("\n        <!DOCTYPE html PUBLIC>\n        <html>\n          <head>\n            <title>Receipt | Order # ".concat(orderNumber, "</title>\n          </head>\n          <body style='text-align:center'\">\n            <div style='display: flex;justify-content: center;text-align: center;'>").concat(html, "</div>\n          </body>\n        </html>\n      "));
            newPopupWindow.print();
        }
    };
    var generateOnClick = function () {
        setIsDrawerOpen(true);
        if (customerType === 'b2c' && !['Online', 'online'].includes(orderOrigin)) {
            return createReceiptImage();
        }
        return handleViewReceipt();
    };
    if (encryptedReceiptRequest || receiptImageSting) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Link, { underline: "hover", variant: page === 'order-details' ? 'body-base' : 'body-sm', decoration: underline ? 'underline' : '', onClick: function () {
                    generateOnClick();
                }, isloading: isLoading, "data-testid": "view-receipt" }, text),
            page === 'order-details' && (React.createElement(Drawer, { open: isDrawerOpen, onClose: function () { return setIsDrawerOpen(false); }, position: "right" },
                React.createElement(DrawerHeader, { title: receiptNumber, onClose: function () { return setIsDrawerOpen(false); } }),
                React.createElement(DrawerBody, { style: { overflowY: 'scroll' } },
                    isLoading ? (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4 sui-m-4 sui-max-h-[62vh] sm:sui-max-h-[80vh] md:sui-max-h-[83vh] lg:sui-max-h-[86vh]" },
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }),
                        React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 12 }),
                        React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 11 }))) : (React.createElement("div", { className: "sui-max-h-[62vh] sm:sui-max-h-[80vh] md:sui-max-h-[83vh] md:sui-pl-[60px] lg:sui-max-h-[86vh] lg:sui-pl-[80px] sui-overflow-y-scroll sui-overflow-visible barcode-fix", dangerouslySetInnerHTML: { __html: receiptImage !== null && receiptImage !== void 0 ? receiptImage : '' } })),
                    alertState && ((_b = alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage.length) !== null && _b !== void 0 ? _b : 0) > 0 && (React.createElement(ViewReceiptAlert, { status: alertState === null || alertState === void 0 ? void 0 : alertState.status, message: (_c = alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage) !== null && _c !== void 0 ? _c : '' }))),
                React.createElement(DrawerFooter, { className: "card-fix sui-p-[16px]" },
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-gap-[16px]" },
                        React.createElement(Button, { variant: "primary", onClick: function () { return printReceiptImage(); } }, "Print")))))));
    }
    return null;
};
